export type ItemStatus = 'OK' | 'DAMAGED' | 'MISSING' | 'NA';

export type ChecklistItemTemplate = {
  key: string;
  label: string;
  /** Key da categoria dinâmica (checklist_item_category). */
  category: string;
  categoryLabel?: string;
  order: number;
};

export type ChecklistItemAnswer = {
  templateKey: string;
  status: ItemStatus;
  note?: string;
};

export type ChecklistItemAnswerDraft = {
  status: ItemStatus | null;
  note: string;
};

export const itemStatusLabel: Record<ItemStatus, string> = {
  OK: 'OK',
  DAMAGED: 'Avariado',
  MISSING: 'Ausente',
  NA: 'N/A',
};

export const itemStatusList: ItemStatus[] = ['OK', 'DAMAGED', 'MISSING', 'NA'];

/** Observação é opcional em todos os itens, para qualquer status (at-34). */
export const NOTE_MAX_LENGTH = 200;
